import React, { useState } from 'react';
import { Container } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import UiContent from '../../../Components/Common/UiContent';
import Calendar from '../../Calendar/Calendar';
import { icon } from 'leaflet';


//redux

const CalendarMaintenance = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Operaciones', icon: 'icon-wrench' },
		{ to: '#', label: 'Mantención', icon: 'icon-wrench' }
	];


	const [categories, setCategories] = useState(['MAN']);


	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Calendario de Mantención' links={breadcrumbLinks} icon={'icon-calendar-range'} />
					<Calendar categories={categories} type={'maintenance'} />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default CalendarMaintenance;
